import React,{Component} from 'react';
import './tools.scss';
import Loader from "../../components/Loader";
import ItemTools from "../../components/ItemTools";
import ItemModality from "../../components/ItemModality";
import ItemContact from "../../components/ItemContact";
import * as Consts from "../common/consts";
import anime from "animejs";

class Tools extends Component {

  constructor(props) {
    super(props);
    this.state = {
      sendMail: false,
      viewCv: false,
      ifeSelect: false,
      isBusy: true,
      txtLoadContact: false,
    };
    this.isBusy = true;
    this.isFirstTime = false;
  }

  sleep(milliseconds) {
    const date = Date.now();
    let currentDate = null;
    do {
      currentDate = Date.now();
    } while (currentDate - date < milliseconds);
  }

  componentDidMount() {


  }

  onLoadedView = () => {
    this.isBusy=!this.isBusy;
    this.setState({isBusy:this.state.isBusy});
    anime({
      targets: ['.body-tools',],
      duration: 1000,
      easing: 'easeInQuad',
      scale: ['0', '1']
    });
  }


  render() {

    let setData = Consts.setTools;
    let setDataOne = [];
    let setDataTwo = [];
    setData = setData.map((itm) => {
      return  <ItemTools description={""} title={itm.title} imageMod={itm.image} />
    });
    setDataOne = setData.slice(0,3);
    setDataTwo = setData.slice(3  ,setData.length);

    return this.isBusy ?
     <Loader required={false} timeLoad={1000} onLoaded={this.onLoadedView} /> :
        <section className={"body-tools"}>
          <div className={"cnt-categories ov-a"}>
            {setDataOne}
            {setDataTwo}
          </div>
          <div  className={"cnt-column2"}>
             <ItemContact type={1} widgetMain={<ItemModality clasCustA={"cur-na"} clasCust={"ic-main-sel-tools"} title={"Tools"} size={"x2"} imageMod={require("../../rsc/assets/iconTools.svg")} />} />
          </div>
        </section>;

  }

  onShowCv = () => {
    if(this.cvElm) {
      this.cvElm.scrollTop = this.cvElm.scrollHeight;
    }
    this.setState({
      viewCv: !this.state.viewCv,
      infoContact:"Gaviria IT Services"
    });
  }

  sendMail = () => {
    window.open("mailto:cristian@gaviria.org");
    this.setState({
      infoContact: "cristian@gaviria.org"
    });
  }

}

export default Tools;
